import { render, staticRenderFns } from "./SourceData.vue?vue&type=template&id=b1c9f5b0&"
import script from "./SourceData.vue?vue&type=script&lang=js&"
export * from "./SourceData.vue?vue&type=script&lang=js&"
import style0 from "./SourceData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports